<template>
  <div class="boss-layout boss-layout-vertical boss-layout-fill">
    <mini-accordion
      :title="'検索条件名： ' + searchConditionName"
      :is-open="true"
    >
      <template v-if="!doSearch || isInitialSearchParameter">
        <span>検索条件なし</span>
      </template>
      <template v-else>
        <div class="grid-x grid-margin-x">
          <search-result-condition
            :job-id="Number($route.params.jobId)"
            class="auto cell"
          />
          <div class="cell shrink end">
            <span
              data-test="search-condition-name-edit"
              class="boss-button boss-button-compact"
              @click="$router.push('search')"
            >この条件を編集する</span>
          </div>
        </div>
      </template>
    </mini-accordion>
    <div>
      <div class="boss-layout boss-layout-fill boss-layout-stretch">
        <div
          class="boss-content-sidemenu"
          style="width: 30%"
        >
          <div class="boss-layout boss-layout-vertical boss-layout-fill">
            <div>
              <span
                class="boss-button boss-button-fill"
                data-test="create-search-condition"
                @click="goCreate"
              >
                <span class="boss-button-before boss-icon-triangle" />
                <span>新規条件で検索</span>
              </span>
            </div>
            <div>
              <search-condition-items
                :job-id="Number($route.params.jobId)"
                :contract-id="Number($route.params.contractId)"
                :do-search="doSearch"
                @refresh="setProperty([])"
                @fetch="fetchMembers"
              />
            </div>
          </div>
        </div>
        <div style="width: 70%">
          <scout-members
            :member-objects="memberObjects"
            :contract-id="Number($route.params.contractId)"
            :job-id="Number($route.params.jobId)"
            :search-name="searchData.name"
            :search-id="searchData.id"
            :count="members.length"
            :count-limit="countLimit"
            :do-search="doSearch"
            display-key="search"
            data-test="scout-members"
            @fetch="fetchMembers"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchResultCondition from '@/components/organisms/SearchResultCondition'
import ScoutMembers from '@/components/organisms/ScoutMembers'
import SearchConditionItems from '@/components/organisms/SearchConditionItems'
import MiniAccordion from '@/components/atoms/MiniAccordion'
import { SearchDataModel } from '@/model/searchDataModel'
import Indicator from '@/lib/indicator'
import _ from 'lodash'

export default {
  components: {
    SearchResultCondition,
    ScoutMembers,
    SearchConditionItems,
    MiniAccordion
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.search(from.name)
    })
  },
  data () {
    return {
      members: [],
      contractId: Number(this.$route.params.contractId),
      countLimit: 1000,
      doSearch: false
    }
  },
  computed: {
    ...mapGetters({
      searchDataByJobId: 'membersSearchCondition'
    }),
    ...mapGetters('contracts', {
      jobBy: 'jobBy'
    }),
    jobId () {
      return Number(this.$route.params.jobId)
    },
    memberObjects () {
      const memberObjects = this.members.map((member) => {
        return { id: member.id, member: member }
      })
      return memberObjects
    },
    isInitialSearchParameter () {
      const initialSearchDataModel = new SearchDataModel()
      return _.isEqual(initialSearchDataModel.parameter, this.searchData.parameter)
    },
    searchData () {
      return this.searchDataByJobId(this.jobId)
    },
    searchConditionName () {
      return this.doSearch ? this.searchData.name || 'なし' : 'なし'
    },
    searchConditionId () {
      return this.searchData.id
    }
  },
  watch: {
    jobId: {
      handler (val) {
        Indicator.emitShow()
        const searchConditionId = Number(this.jobBy(this.contractId, val).searchConditionId)
        if (searchConditionId === 0) { // searchConditionIdはdefaultで0
        // 検索条件が1件もないため、検索条件新規作成画面に飛ばす
          this.goCreate()
        } else {
          this.setProperty([])
          this.doSearch = false
          Indicator.emitHide()
        }
      }
    }
  },
  methods: {
    // beforeRouteEnterのnextがテスト実施時には空関数になってしまいテストできないため、処理を関数に切りだす
    search (fromName) {
      if (fromName === 'scoutSearch') {
        this.doSearch = true
        !this.isInitialSearchParameter && this.fetchMembers()
      }
    },
    fetchMembers () {
      this.doSearch = true
      // 検索条件IDがある場合、最終検索日時をバック側で更新するので付与
      const apiParameter = { ...this.createAPIParameter(), searchConditionId: this.searchData.id }

      Indicator.emitShow()
      this.$http.secured.post(`/scout/view/contracts/${this.contractId}/jobs/${this.jobId}/users/_search`, apiParameter)
        .then(response => {
          const members = this.omitMembers(response.data)
          this.setProperty(members)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    createAPIParameter () {
      const apiParameter = _.cloneDeep(this.searchData.parameter)
      if (apiParameter.skills && apiParameter.skills.conditions) {
        apiParameter.skills.conditions = apiParameter.skills.conditions.filter(condition => condition.years.minimum !== '')
      }
      if (apiParameter.occupations.desired) {
        apiParameter.occupations.desired = apiParameter.occupations.desired.map(x => x.id)
      }
      if (apiParameter.occupations.experienced) {
        apiParameter.occupations.experienced = apiParameter.occupations.experienced.filter(x => x.years.minimum !== '')
      }
      return apiParameter
    },
    setProperty (members) {
      this.$set(this, 'members', members.map(member => _.set(member, 'isScoutExcluded', false)))
    },
    omitMembers (members) {
      return members.length > 999 ? members.slice(0, 999) : members
    },
    goCreate () {
      this.$router.push({
        name: 'scoutSearch',
        params: {
          create: true,
          jobId: this.jobId,
          contractId: this.contractId
        }
      })
    }
  }
}
</script>
